export const FormatTypes = {
    DATE_FORMAT: 'dd/MM/yyyy',
    VALID_DATE_CHARS: /(\d|\/)/
};
